// Files Service - Service layer for file upload/download operations

import { uploadInstance } from '../instance/axiosInstance';
import axiosInstance from '../instance/axiosInstance';
import { FILES_ENDPOINTS } from '../endpoints/files.endpoints';
import { handleApiError } from '../utils/errorHandler';
import { serializeParams } from '../utils/paramSerializer';

export const FilesService = {
  // Upload files to backend DB
  uploadFiles: async (payload) => {
    try {
      const response = await uploadInstance.post(FILES_ENDPOINTS.UPLOAD_BATCH, payload);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Get all files for a specific order
  getALLFiles: async (orderId) => {
    try {
      const response = await axiosInstance.get(FILES_ENDPOINTS.GET_ALL(orderId), {
        paramsSerializer: serializeParams,
      });

      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Replace an existing file
  replaceFile: async (payload) => {
    try {
      const response = await uploadInstance.put(FILES_ENDPOINTS.REPLACE, payload);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Delete a single file
  deleteOneFile: async (fileUploadId, deletedBy) => {  
    try {
      const response = await axiosInstance.delete(FILES_ENDPOINTS.DELETEONE(fileUploadId, deletedBy));
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Delete all files for a specific order
  deleteAllFiles: async (orderId) => {
    try {
      const response = await axiosInstance.delete(FILES_ENDPOINTS.DELETEALL(orderId));
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Log confirm mapping clicked activity
  logConfirmMappingClicked: async (orderId, userEmail) => {
    try {
      const response = await axiosInstance.post(FILES_ENDPOINTS.ACTIVITY_LOG, {
        orderId: String(orderId),
        userEmail: userEmail,
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // SAS Token cache
  _sasTokenCache: {
    token: null,
    containerUrl: null,
    expiresAt: null,
  },

  // Token refresh interval (30 minutes in milliseconds)
  SAS_TOKEN_REFRESH_INTERVAL: 30 * 60 * 1000,

  // Get a fresh SAS token from the backend API
  // Returns the full SAS URL (container URL + token) for direct use
  // Throws error if API fails - no fallback to environment variables
  getSasToken: async () => {
    const accountName = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT_NAME;
    const containerName = process.env.REACT_APP_AZURE_STORAGE_CONTAINER_NAME;
    
    if (!accountName || !containerName) {
      throw new Error('Azure storage account name or container name not configured in environment variables');
    }
    
    try {
      // Get SAS token from API
      const response = await axiosInstance.get(FILES_ENDPOINTS.GET_SAS_TOKEN);
      console.log('Fetched SAS Token response:', response.data);
      
      const { sasToken } = response.data;
      
      if (sasToken) {
        const sasUrl = `https://${accountName}.blob.core.windows.net/${containerName}?${sasToken}`;
        console.log('Constructed SAS URL from API token:', sasUrl);
        return { sasUrl };
      }
      
      // If API returned empty token, throw error
      throw new Error('API returned empty SAS token');
    } catch (error) {
      // API call failed, throw error with meaningful message
      console.error('Failed to get SAS token from API:', error.message);
      throw new Error(`Failed to get SAS token: ${error.message || 'Unknown error'}`);
    }
  },

};

export default FilesService;
